var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import React, { Component } from 'react';
import { Avatar, DropDownMenu, Option } from '@philips-internal/oswald-ui-components/lib/components';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { AuthenticationService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext, foundationContext } from '@philips-internal/oswald-ui-foundation';
import { generateUUID } from '@philips-internal/oswald-ui-utils';
import UserProfileApi from './user-profile-api';
import './user-profile.css';
let UserProfile = class UserProfile extends Component {
    constructor(props) {
        super(props);
        this.openProfileSettings = (id) => {
            applicationContext.redirect('/application/user/:id', { id });
        };
        this.logOut = () => {
            void AuthenticationService.logout().then(() => {
                AuthenticationService.redirectToLogin();
            });
        };
        this.state = {
            loaded: false,
            subTitle: '',
            ...props,
        };
    }
    componentDidMount() {
        const { loaded } = this.state;
        if (!loaded && !foundationContext.isEmpty()) {
            const state = {};
            const user = foundationContext.getUser();
            const establishment = foundationContext.getEstablishment();
            const sector = foundationContext.getSector();
            if (user) {
                state.userId = user.id;
                state.userName = user.name;
                state.image = user.image;
            }
            if (establishment && establishment.name) {
                state.subTitle = establishment.name;
            }
            if (sector && sector.name) {
                state.subTitle += ` - ${sector.name}`;
            }
            state.loaded = true;
            this.setState(state);
        }
    }
    render() {
        const { userName, image, subTitle, userId } = this.state;
        return (React.createElement("div", { className: "c-user-profile-container c-user-profile-panel t-light c-user-profile" },
            React.createElement(DropDownMenu, { uuid: generateUUID() },
                React.createElement("div", { slot: "header" },
                    React.createElement(Avatar, { className: "c-user-profile-avatar-bar", image: image, title: userName, subtitle: subTitle })),
                React.createElement("div", { slot: "content", className: "c-user-profile-container c-user-profile-panel c-user-profile-panel-profile-links" },
                    React.createElement(Option, { value: "tws.spotlight.profile", onClick: () => this.openProfileSettings(userId) }),
                    React.createElement(Option, { value: "tws.spotlight.logout", onClick: () => this.logOut() })))));
    }
};
UserProfile = __decorate([
    AwesomeComponent({ type: ComponentType.DATA_DISPLAY, api: UserProfileApi }),
    __metadata("design:paramtypes", [Object])
], UserProfile);
export default UserProfile;
//# sourceMappingURL=user-profile.js.map